<template>
    <div class="container page">
        <van-nav-bar :title="$t('hc')" class="nav-bar">
        </van-nav-bar>
        <div style="height:54px;"></div>
        <div class="list-wrap">
            <!-- 列表项 -->
            <a class="list-item" v-for="(item, index) in listData" :key="index" @click="toUrl(item.path)">
                <!-- 左侧Logo -->
                <div class="item-logo">
                    <img :src="item.logo" alt="logo" />
                </div>

                <!-- 中间名称 -->
                <div class="item-name">
                    {{ item.name }}
                </div>

                <!-- 右侧区域：信息 + 头像 + 箭头 -->
                <div class="item-right">
                    <span class="item-info">{{ item.info }}</span>
                    <div class="avatar">
                        <img :src="item.avatar" alt="头像" />
                    </div>
                    <span class="arrow">
                        <i class="iconfont icon-youjiantou"></i>
                    </span>
                </div>
            </a>
        </div>
        <div class="list-wrap2">
            <div class="boxs" @click="toUrl('/Lottery')">
                <div class="t">{{ $t('会员权利') }}</div>
                <div class="text">Authentication datav ①</div>
                <img src="../../assets/image/g1.png" alt="">
            </div>
            <div class="boxs" @click="toUrl('/Lottery')">
                <div class="t">{{ $t('会员权利') }}</div>
                <div class="text">Authentication datav ②</div>
                <img src="../../assets/image/g2.png" alt="">
            </div>
            <div class="boxs" @click="toUrl('/Lottery')">
                <div class="t">{{ $t('会员权利') }}</div>
                <div class="text">Authentication datav ③</div>
                <img src="../../assets/image/g1.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            listData: [
                {
                    logo: require('../../assets/image/syc.png'),
                    name: this.$t('会员视频'),
                    info: "Riding on him and moving",
                    avatar: require('../../assets/image/cs.png'),
                    path:'/Video'
                },
                {
                    logo: require('../../assets/image/fl1.png'),
                    name: this.$t('hc'),
                    info: "Newly Joined ID 232***",
                    avatar: require('../../assets/image/cs.png'),
                    path:'/BenefitsList'
                }
            ]
        }
    },
    methods:{
        toUrl(url){
            this.$router.push(url)
        }
    }
}
</script>


<style scoped lang="less">
.container {
    position: relative;
    width: 100%;
    height: fit-content;
    min-height: 100dvh;
    background: #f2f2f5 url('../../assets/image/bgj.png') no-repeat center top / 100%;
    padding: 0 10px;
}
.nav-bar {
    background: none;
}
::v-deep .van-nav-bar__title {
    color: #000 !important;
}
.list-wrap {
    width: 100%;
    padding: 15px;
}

.list-item,.list-wrap2 {
    display: flex;
    align-items: center;
    padding: 20px 16px;
    gap: 20px;
    background: linear-gradient(30deg, #d63f8c, #7d76ef);
    border-radius: 10px;
    margin-bottom: 20px;
}
.list-wrap2 {
    padding:15px;
    background: none;
    display: flex;
    flex-direction: column;
    .boxs {
        width: 100%;
        height: 270px;
        position: relative;
        background: #E9EAEC;
        img {
            display: block;
            width:100%;
            height: 100%;
        }
        .t {
            position: absolute;
            top: 8px;
            left: 12px;
            color: #fff;
            font-size: 24px;
        }
        .text {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 20px;
            color: #000;
        }
    }
}

.item-logo  {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* logo */
.item-logo img {
    width: 60px;
    height: 60px;
    border-radius: 6px;
    object-fit: cover;
}

/* 中间名称：自动占剩余宽度，文字溢出省略 */
.item-name {
    flex: 1;
    color: #ffffff;
    font-size: 28px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 右侧弹性布局 */
.item-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.item-info {
    font-size: 28px;
    color: #fff;
}

.avatar img {
    width: 62px;
    height: 62px;
    border-radius: 4px;
    object-fit: cover;
}

.arrow {
    font-size: 18px;
    color: #c8c9cc;
    .iconfont {
        font-size: 24px;
        color: #000;
    }
}
</style>